import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/baseUi/avatar"
import { cn } from "@/modules/lib/utils"
import { CoachEntity } from "@modules/profile/coachProfile/coachEntity"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
import { Text } from "@/components/ui/baseUi/text"

type AvatarProps = {
  profile: Pick<UserEntity | CoachEntity, "avatar" | "username">
  className?: string
  classNameImage?: string
  classNameFallback?: string
  alt?: string
} & React.ComponentProps<typeof Avatar>

export function ProfileAvatar({ profile, className, classNameImage, classNameFallback, alt, ...props }: AvatarProps) {
  return (
    <Avatar className={cn("size-10", className)} {...props}>
      <AvatarImage src={profile.avatar?.url} className={cn("object-cover", classNameImage)} alt={alt} />
      <AvatarFallback className={cn("bg-neutral-200", classNameFallback)}>
        <Text className="font-semibold text-neutral-700">{profile.username[0]?.toUpperCase()}</Text>
      </AvatarFallback>
    </Avatar>
  )
}
